import React from 'react';
import {
  Grid,
} from "@mui/material";
import Section1 from '../Show/Section1';
import National from '../National/National';
import Qualification from '../Qualification/Qualification';
import AddressDetails from '../AddressDetails/Address';
import Payment from '../Payment/Payment';
import Rating from '../Ratings/index';

const Show = (props) => {
  const { name,item } = props;
  return (
    <Grid style={{boxShadow: 8,  backgroundColor: '#FCFCFC'}}>
  <Section1 data={item} name={name} />
 
  <National heading={'National ID'} Subheading={'ID number '} ID={"00 11 22 22 44 55"} />
 
  <Qualification heading={'Qualification'} Subheading={'Diploma graduate in Course name'} />


  <AddressDetails/>

  <Payment />
  {item.status==="Approved"?(
  <Rating name={name} />
  ):null
  
  }

    </Grid>
  
 


  )
}

export default Show;